import type { AccountInfo } from "@azure/msal-browser";

/**
 * Pick the cached account that belongs to THIS instance's Entra tenant.
 *
 * The app is multi-tenant, so a user can legitimately be signed into a second account from another
 * tenant (e.g. a personal/Sunlarus account alongside their Christie Lites one). Blindly activating
 * `getAllAccounts()[0]` can silently select that foreign account, whose access token the API rejects —
 * leaving the UI stuck on loading skeletons with no obvious cause. Selecting strictly by tenant avoids
 * that trap; when no in-tenant account is cached we return `undefined` so the caller falls back to an
 * interactive sign-in (account picker) instead of activating the wrong one.
 */
export function selectInTenantAccount(
  accounts: AccountInfo[],
  tenantId: string
): AccountInfo | undefined {
  if (!tenantId) return undefined;
  return accounts.find((a) => a.tenantId === tenantId);
}
